import _ from 'lodash';

export default (regionOptions) => {
  const split = _.partition(regionOptions, o => isNaN(o.value.charAt(0)));
  const sortedNums = split[1].sort((a, b) => {
    const x = Number(a.value.match(/\d+/g));
    const y = Number(b.value.match(/\d+/g));
    return (x > y)
      ? -1
      : 1;
  });

  const alphaSort = split[0].sort((a, b) => ((a.value.toUpperCase() < b.value.toUpperCase())
    ? -1
    : 1));

  const fedCircuit = _.remove(alphaSort, { value: 'CAFC' });
  const x = alphaSort.concat(fedCircuit);

  return sortedNums.concat(x);
};



// WEBPACK FOOTER //
// ./src/data/regionsSorter.js